import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        <div className="relative h-[300px] md:h-[400px] lg:h-[500px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20flat%20lay%20photography%20of%20premium%20fashion%20items%20including%20designer%20scarf%20leather%20gloves%20and%20stylish%20wallet%20on%20cream%20beige%20linen%20texture%2C%20soft%20natural%20window%20light%2C%20clean%20editorial%20aesthetic%2C%20warm%20neutral%20tones%2C%20luxurious%20organic%20composition&width=800&height=600&seq=cta-split-2026-v2&orientation=landscape"
            alt="Premium AllChinaBuy Spreadsheet product collection showcase"
            title="AllChinaBuy Spreadsheet - Verified Products Collection"
            className="w-full h-full object-cover object-top"
            loading="lazy"
          />
        </div>

        <div className="flex flex-col items-center justify-center px-6 md:px-12 py-14 md:py-16 bg-background-50 text-center">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4 leading-tight">
            Start Browsing the Latest<br />
            AllChinaBuy Spreadsheet<br />
            Today
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-md mb-8 leading-relaxed">
            Join thousands of savvy shoppers who use our AllChinaBuy Spreadsheet to find the best products, verified sellers, and save money on every purchase.
          </p>
          <div className="flex flex-col sm:flex-row items-center gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-xl text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors flex items-center gap-1.5"
            >
              Browse Spreadsheet
              <i className="ri-arrow-right-up-line text-xs"></i>
            </a>
            <Link
              to="/articles/shopping-guide-2026"
              className="px-8 py-3.5 bg-background-100 text-foreground-900 border border-background-200 rounded-xl text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-background-200 transition-colors flex items-center gap-1.5"
            >
              Shopping Guide
              <i className="ri-arrow-right-line text-xs"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}